exports.en = {
  UNIFORM_OW_INPUT_TEL: {
    INVALID_INPUT: 'Error.',
    INVALID_FORMAT: 'Invalid phone number format.',
    ERROR_REQUIRED: 'Please fill in.',
    ARIA_LABEL: 'Phone number'
  }
}
